import { getSupportedLanguages } from '../../utils/languageUtils';

const allowedOnboardingPaths = new Set([
  '/company-verification',
  '/google-business',
  '/google-business/confirm',
]);

export const getSafeFlipdishAppTarget = (search: string): string | null => {
  const target = new URLSearchParams(search).get('target');
  if (!target) {
    return null;
  }

  try {
    const targetUrl = new URL(target);
    const onboardingPath = targetUrl.searchParams.get('onboardingPath');
    if (
      targetUrl.protocol !== 'flipdish:' ||
      targetUrl.hostname !== 'home' ||
      !onboardingPath ||
      !allowedOnboardingPaths.has(onboardingPath)
    ) {
      return null;
    }

    return targetUrl.toString();
  } catch {
    return null;
  }
};

export const getBridgeLanguage = (search: string): string | null => {
  const lang = new URLSearchParams(search).get('lang');
  if (!lang) {
    return null;
  }
  return getSupportedLanguages().includes(lang) ? lang : null;
};
